"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerOptionsConfig = void 0;
const options_1 = require("@ganache/options");
const server_defaults_1 = require("./server-defaults");
exports.ServerOptionsConfig = new options_1.OptionsConfig(server_defaults_1.serverDefaults);
//# sourceMappingURL=server-options-config.js.map